export default {
  PRE_DASH: 'pre_dashboard',
  PRE_APPROVED_DASH: 'pre_approved_dashboard',
  POST_DASH: 'post_dashboard',
  CONTRACT_SIGN: 'contract_signature',
};
